module["exports"] = [
  "gmail.com",
  "zoznam.sk",
  "azet.sk"
];



/*****************
 ** WEBPACK FOOTER
 ** ./~/faker/lib/locales/sk/internet/free_email.js
 ** module id = 957
 ** module chunks = 0
 **/